import { createFileRoute } from '@tanstack/react-router';
import { EndorsementControlsPage } from '@/pages/chain/endorsement/EndorsementControlsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/chain/endorsement')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['chainConfig.manageBranding'],
			redirectTo: '/dashboard',
		}),
	component: EndorsementControlsPage,
});
